import React from "react";

export default function Footer() {
  return (
    <footer className="py-4 md:py-20 text-center text-sm">
      <p>©2021 by SquareMeter Systems Ltd.</p>
    </footer>
  );
}
